var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPediatricPad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Baby"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M81.92 51.37L64.49 35.39C62.59 33.65 60.35 32.42 57.95 31.64C61.93 28.76 64.55 24.11 64.55 18.83C64.55 10.1 57.45 3 48.72 3C39.99 3 32.89 10.1 32.89 18.83C32.89 24.11 35.51 28.76 39.49 31.64C37.09 32.42 34.85 33.65 32.95 35.39L15.52 51.37C13.98 52.79 13.1 54.79 13.1 56.88C13.1 61 16.46 64.36 20.72 64.36C22.69 64.36 24.61 63.56 26.01 62.17L33.11 55.07C33.33 57.49 33.74 59.83 34.32 62.07L27.19 71.97C24.42 75.66 24.28 80.72 26.84 84.56L33.68 94.83C35 96.82 37.22 98.01 39.63 98.01C43.56 98.01 46.75 94.81 46.75 90.89V89.92C46.75 88.31 46.2 86.73 45.19 85.47L39.67 78.58L42.78 76.25C46.55 78.87 50.9 78.87 54.67 76.25L57.78 78.58L52.27 85.47C51.26 86.73 50.71 88.3 50.71 89.92V90.89C50.71 94.82 53.91 98.01 57.85 98.01C60.23 98.01 62.46 96.82 63.78 94.84L70.7 84.46C73.21 80.69 73.08 75.73 70.38 72.13L63.14 62.09C63.72 59.84 64.12 57.5 64.35 55.09L71.45 62.19C72.84 63.58 74.77 64.38 76.88 64.38C81 64.38 84.36 61.02 84.36 56.9C84.36 54.81 83.48 52.81 81.94 51.39L81.92 51.37ZM48.72 74.25C44.59 74.25 40.63 69.57 38.49 62.37H58.95C56.81 69.57 52.85 74.25 48.72 74.25Z",
    fill: "#0C71C3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPediatricPad);
export default __webpack_public_path__ + "static/media/pediatricPad.78b7abc716bfacea4a5a055d19c9a62b.svg";
export { ForwardRef as ReactComponent };